export default __webpack_public_path__ + "static/media/digitaleyes.d3289ec6.svg";